module.exports = require("./mas.d.ts");